import { useEffect, useRef } from 'react'

import { MS_IN_SECOND } from 'conversations/utils/timeConstants'
import { useSelector } from 'react-redux'

const MS_DELAY_BETWEEN_REFETCHES = MS_IN_SECOND * 5

export default function useSocketReconnect(onReconnect: () => void) {
  const isConnected = useSelector((store: any) => store.socket?.isConnected() ?? false)
  const prevRefetchTime = useRef(0)
  const connected = useRef(false)
  const numTimesConnected = useRef(0)

  useEffect(() => {
    if (isConnected && !connected.current) {
      connected.current = true
      numTimesConnected.current += 1
      const currentTime = new Date().getTime()

      // Ignore the first connection attempt and have a buffer between fetches
      if (
        numTimesConnected.current > 1 &&
        currentTime - prevRefetchTime.current > MS_DELAY_BETWEEN_REFETCHES
      ) {
        prevRefetchTime.current = currentTime
        onReconnect()
      }
    }

    if (!isConnected) {
      connected.current = false
    }
  }, [isConnected, onReconnect])
}
